import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { AdminDashboardPage } from './adminDashboard';
import { CalendarModule } from 'ion2-calendar';
import { RestProvider } from '../../providers/rest/rest';

@NgModule({
  declarations: [
    AdminDashboardPage,
  ],
  imports: [
    IonicPageModule.forChild(AdminDashboardPage),
    CalendarModule,
  ],

  entryComponents: [
  ],
  providers: [
    RestProvider,
  ]
})
export class AdminDashboardPageModule {}



// WEBPACK FOOTER //
// ./src/pages/adminDashboard/adminDashboard.module.ts